<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "ContratoRenovacao"
    }
  },
  data: () => ({
    contratoList: {}
  }),
  created() {
    this.getContratoList();
  },
  methods: {
    get(id) {
      api.get(`crud/${this.table}/${id}`).then(response => {
        this.item = response.data["data"];
      });
    },
    getContratoList() {
      api
        .get(`crud/Contrato`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.contratoList = response.data["data"]));
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Contrato" label-for="contratoId">
        <b-form-select
          id="contratoId"
          v-model="item.contratoId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in contratoList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Data de início"
          label-for="data"
          class="col-md-6"
        >
          <b-form-datepicker
            id="dataInicio"
            v-model="item.dataInicio"
            :disabled="!this.editForm"
            required
            placeholder="Selecione uma data"
            :hide-header="true"
          ></b-form-datepicker>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Data de término"
          label-for="dataFim"
          class="col-md-6"
        >
          <b-form-datepicker
            id="dataFim"
            v-model="item.dataFim"
            :disabled="!this.editForm"
            required
            placeholder="Selecione uma data"
            :hide-header="true"
          ></b-form-datepicker>
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Carga horária (horas)"
          label-for="cargaHoraria"
          class="col-md-3"
        >
          <b-form-input
            id="cargaHoraria"
            v-model="item.cargaHoraria"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999.00"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Valor cobrado (R$)"
          label-for="valorCobrado"
          class="col-md-3"
        >
          <b-form-input
            id="valorCobrado"
            v-model="item.valorCobrado"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Excedente remoto (R$)"
          label-for="valorCobrado"
          class="col-md-3"
        >
          <b-form-input
            id="valorCobrado"
            v-model="item.horaAvulsaRemota"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Excedente presencial (R$)"
          label-for="valorCobrado"
          class="col-md-3"
        >
          <b-form-input
            id="valorCobrado"
            v-model="item.horaAvulsaPresencial"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group
        id="input-group-1"
        label="Observação"
        label-for="observacao"
      >
        <b-form-textarea
          id="observacao"
          v-model="item.observacao"
          placeholder="Observação..."
          type="text"
          :disabled="!this.editForm"
          rows="5"
        />
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
